import { useState } from "react";
import { toast } from "sonner";
import { Siren, RefreshCw } from "lucide-react";
import { api, errMsg, istDateTime } from "@/lib/api";

const legText = (o) => `${o.side === "BUY" ? "LONG" : "SHORT"} ${o.qty} × ${o.strike ?? ""}${o.type ?? ""} @ ₹${o.avg}`;

export const PositionAlarm = ({ alarm, onRecheck }) => {
  const [busy, setBusy] = useState(false);
  if (!alarm) return null;
  const recheck = async () => {
    setBusy(true);
    try {
      const r = (await api.post("/execution/reconcile")).data;
      toast[r.ok ? "success" : "error"](r.ok ? "Positions match Dhan again" : "Still mismatched; entries stay blocked");
      onRecheck?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="position-alarm-banner" role="alert" className="pulse-border flex flex-wrap items-start gap-3 border-y-2 border-red-600 bg-red-600 px-3 py-2.5 text-white sm:px-4">
      <Siren size={18} className="mt-0.5 shrink-0 animate-pulse" />
      <div className="min-w-0 flex-1 text-xs leading-relaxed">
        <div className="text-sm font-bold tracking-wide">POSITION ALARM · NEW ENTRIES BLOCKED</div>
        {alarm.mismatch && (
          <div data-testid="position-alarm-mismatch">
            Dhan's positions don't match what the bot holds:{" "}
            {alarm.diffs && typeof alarm.diffs === "object"
              ? Object.entries(alarm.diffs).map(([sid, d]) => `security ${sid}: bot ${d.expected}, Dhan ${d.broker}`).join(" · ")
              : alarm.reason || "safety halt"}
            {alarm.reconciled_at && <span className="opacity-80"> (checked {istDateTime(alarm.reconciled_at)})</span>}
          </div>
        )}
        {alarm.attention?.map((a) => (
          <div key={a.trade_id} data-testid={`position-alarm-attention-${a.trade_id}`}>
            Unhedged leg ({a.book}) · {a.strategy}: {a.orphans.map(legText).join(", ")}. The bot retries closing it every cycle.
          </div>
        ))}
        <div className="opacity-90">Check your Dhan positions. Live entries resume automatically once everything reconciles clean.</div>
      </div>
      <button data-testid="button-position-recheck" disabled={busy} onClick={recheck}
        className="flex shrink-0 items-center gap-1 rounded bg-white px-3 py-1.5 text-xs font-semibold text-red-700 transition-colors hover:bg-red-50 disabled:opacity-60">
        <RefreshCw size={12} className={busy ? "animate-spin" : ""} /> {busy ? "Checking…" : "Re-check now"}
      </button>
    </div>
  );
};
